document.addEventListener("DOMContentLoaded", ()=>{

    /*Mobile menu functionality*/
    const mobMenuToggler = document.querySelector('.js-toggle-custom-menu')
    const mobMenu = document.querySelector('.custom-mobile-menu')
    mobMenuToggler.addEventListener("click", (e)=>{
        if(document.querySelector('.site-header').classList.contains('header-active') && window.scrollY<70){
          document.querySelector('.site-header').classList.remove('header-active')
        }else{
          document.querySelector('.site-header').classList.add('header-active')
        }
        mobMenu.classList.toggle('active')
        e.target.classList.toggle('active')
    })

    //Hide menu in case we click outside
    document.addEventListener("click", (e)=>{
        //Check if menu is opened
        if(!mobMenu.classList.contains('active') || e.target.closest('.custom-mobile-menu') || e.target.classList.contains('js-toggle-custom-menu')){
            return
        }
        // If user clicks outside the menu, hide it!
        mobMenu.classList.toggle("active")
        mobMenuToggler.classList.toggle("active")
        if(window.scrollY<70){
          document.querySelector('.site-header').classList.remove('header-active')
        }
    })



    /* End Mobile menu functionality */





    //Free shipping adjustments
    document.addEventListener("fs-update", ()=>{
      console.log("Tengo el evento")

      //Fetch al cart
      fetch(`${window.theme.routes.cart_url}`)
        .then((response) => {
          return response.text();
        })
        .then((html) => {
          const responseHtml = new DOMParser().parseFromString(html, 'text/html')
          console.log(responseHtml)
          console.log(responseHtml.querySelector('#main-cart-footer'))
          const fsText = responseHtml.querySelector('#main-cart-footer .cart-free-shipping').innerHTML
          document.querySelector('.cart-free-shipping').innerHTML = fsText
    
        })
    })
})



/* Localization form */
class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
  
      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }
  
    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }
  
    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
  
      this.hidePanel();
      this.elements.button.focus();
    }
  
    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }
  
    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }
  
    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }
  
  customElements.define('localization-form', LocalizationForm);
  